import {fork} from 'redux-saga/effects'
import {authSaga} from './modules/auth/sagas'
import {profileSaga} from './modules/profile/sagas'
import {orderSaga} from './modules/order/sagas'

export function* sagas() {
    yield fork(authSaga)
    yield fork(profileSaga)
    yield fork(orderSaga)
}
